import { Link } from "@mui/material";
import React from "react";
import styles from "../components/laymanComp_css/LaymanPage32.module.css";

export default function LaymanPage32() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div
                className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
              >
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF CANCER</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.cancer_block_main}>
                <div
                  className={`${styles.cancer_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.cancer_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block1_img.webp"
                    /> */}
                     <img className={styles.cancer_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block1_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div class={styles.layman_yellow_commn_header}>
                        <h2>
                          Cancer's Embrace: Navigating the Cosmic Sea of Meaning
                        </h2>
                      </div>
                      <p>
                        Cancer, a cosmic archetype intricately interwoven into
                        the tapestry of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                        method and Archetypal Astrology, emerges as a Cardinal
                        Water Influence—a pure and sudden onrush of the
                        emotional element. In the vast realm of personal
                        experience, Cancer represents the highest emotional
                        drives, those poignant moments that etch themselves into
                        our memory, shaping the course of our lives.
                      </p>
                      <p>
                        As the cardinal water flows, it brings forth profound
                        emotional experiences—those moments when you realize
                        you're in love, the transformative words of a speaker
                        that reshape your perspective, or the first encounter
                        with the world as a living, breathing entity filled with
                        nature's spiritual presence, connected to the Anima
                        Mundi—the soul of the Earth. These experiences forge an
                        emotional <i>"knowingness,"</i> a deep sensibility that serves
                        as a guiding force. It is the driving element that gives
                        meaning to our existence and acts as a compass,
                        directing the currents of personal will and Magick.
                      </p>

                      <p>
                        The Thoth Arcana associated with Cancer is the Chariot,
                        a card of great significance in understanding the
                        cardinal emotional meaning. The Charioteer, fully lit by
                        Cancer's planetary ruler, the moon, reflects perfection.
                        With armor representing complete knowledge and guided by
                        the music of the heart, the Charioteer holds the Cup of
                        Babylon, symbolizing the lifeblood of our evolutionary
                        journey. This cup overflows with the ecstasies of
                        following our life purpose.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className={`${styles.cancer_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block2_img.webp`}/>
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr}`}>
                    <div className={styles.layman_txt_box_innr}>
                      <p className={styles.one_sqr_bullt}>
                        A profound secret lies within the Chariot—the chariot
                        itself remains still. The Charioteer, brimming with the
                        highest emotional spirit, is the active agent. In this
                        stillness, the Chariot is <i>"Absolutely Present"</i> at the
                        point of Cosmic Ingression and Transpersonal becoming.
                        It is here that meaning exists, and the realization of
                        Magick unfolds.
                      </p>

                      <p>
                        Working under the influence of Cancer is an invitation
                        to pay close attention to the driving forces, both
                        within yourself and others. It beckons individuals to
                        connect with the emotional knowing that arises through
                        introspection and quiet reflection. Cancer encourages
                        the review of motives, realigning them with more basic
                        principles—delving into the question of what is truly
                        meaningful. It is an exploration of where experiences
                        can be driven to deepen the forces of Cancer, taking
                        directions that resonate most closely with the heart's
                        truest desires.
                      </p>

                      <p>
                        In conclusion, Cancer's embrace is a journey into the
                        cosmic sea of meaning, where the currents of emotional
                        knowing guide us to the heart of our existence. As
                        seekers embrace the archetypal instinct of Cancer, they
                        embark on a voyage of self-discovery, navigating the
                        waves of profound emotion to find purpose, meaning, and
                        the realization of their deepest desires.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.cancer_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block3_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block3_img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_wrapper} `}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <div class={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <div className={styles.bullet_wrapper}>
                        <p>
                          <strong>Cosmic Archetype:</strong> Cancer is a
                          powerful Cosmic Archetype within <Link href="https://www.divineinfinitebeing.com">the School of Divine
                          Infinite Being</Link> method and Archetypal Astrology,
                          representing a Cardinal Water Influence.
                        </p>
                        <p>
                          <strong>Cardinal Water Influence: </strong>
                          Cancer embodies a Cardinal Water nature, signifying a
                          sudden and pure onrush of the emotional element,
                          influencing the highest emotional drives.
                        </p>
                        <p>
                          <strong>Profound Emotional Experiences:</strong>{" "}
                          Cancer symbolizes those moments etched in memory, such
                          as realizing one's in love or encountering
                          transformative words, shaping the trajectory of one's
                          life.
                        </p>
                        <p>
                          <strong>Connection to Anima Mundi:</strong> Cancer's
                          influence connects with the Anima Mundi, the soul of
                          the Earth, fostering a deep sensibility and spiritual
                          presence in the natural world.
                        </p>
                        <p>
                          <strong>Guiding Force:</strong> The emotional
                          <i>"knowingness"</i> of Cancer acts as a guiding force,
                          giving meaning to personal existence and providing
                          direction in life, Magick, and personal will.
                        </p>

                        <p>
                          <strong>Thoth Arcana - Chariot:</strong> Cancer is
                          associated with the Chariot in the Thoth Tarot,
                          symbolizing the highest emotional spirit, complete
                          knowledge, and the overflowing lifeblood of our
                          evolutionary journey.
                        </p>

                        <p>
                          <strong>Charioteer's Direction:</strong> The
                          Charioteer, fully lit by the moon (Cancer's planetary
                          ruler), reflects perfection, and the Chariot itself
                          remains still, symbolizing absolute presence at the
                          point of Cosmic Ingression and Transpersonal becoming.
                        </p>
                        <p>
                          <strong>Magick Realization: </strong>
                          Cancer's influence at the point of stillness allows
                          for the realization of Magick, where meaning is
                          discovered and profound cosmic insights unfold.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.cancer_block4_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}
                >
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block4_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_cancer/cancer_block4_img.webp`}/>
                  </div>

                  <div
                    className={`${styles.layman_txt_box_wrpr} ${styles.bullet_wrapper} `}
                  >
                    <div className={styles.layman_txt_box_innr}>
                      <p>
                        <b>Introspection and Quiet Reflection:</b> Working under
                        the influence of Cancer involves connecting with
                        emotional knowing through introspection and quiet
                        reflection, understanding the driving forces within.
                      </p>

                      <p>
                        <b>Motive Review: </b> Cancer encourages the review of
                        motives, urging individuals to realign them with more
                        basic principles and explore the deeper meanings that
                        guide life's course.
                      </p>
                      <p>
                        <b>Meaningful Exploration:</b> Cancer invites
                        individuals to explore what is truly meaningful,
                        deepening the understanding of personal desires and
                        resonating with the core principles that drive life's
                        purpose.
                      </p>
                      <p>
                        <b>Emotional Sensibility: </b>
                        Cancer fosters emotional sensibility, emphasizing the
                        importance of being attuned to one's emotions and
                        recognizing their significance in decision-making and
                        life navigation.
                      </p>
                      <p>
                        <b>Voyage of Self-Discovery:</b> Cancer's influence
                        initiates a voyage of self-discovery, navigating the
                        cosmic sea of meaning, purpose, and the profound desires
                        of the heart.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                 
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>
                          The Astrological Tarot association for Cancer <br />{" "}
                          is The Chariot. See our alchemical ROTA here
                        </h1>
                      </div>
                    </Link>
                  
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/layman_page32_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/layman_page32_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/layman_page32_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/layman_page32_block4_demo_img.webp'></img>
              </div>

              <div className={styles.block5_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_cancer/layman_page32_block5_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
